import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { RootState } from '../../../../../setup';
import {
  KTSVG,
  LoadingGrid,
  maskPhoneNumber,
  formatDateMonth,
  formatTime,
  formatPriceMejorado,
  SimpleAlert,
} from '../../../../../_mexablock/helpers';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { Filter } from '../../../pagos/pagados/components/Filter';
import { PortabilityModal } from '../_modals/PortabilityModal';
import { PortabilityActivationModal } from '../_modals/PortabilityActivationModal';
import { TopUpBalanceModal } from '../../../../../_mexablock/partials/modals/balance/TopUpBalanceModal';
import { useGetAll } from '../hooks/PortabilidadHook';
import { ConfirmModal } from '../_modals/ConfirmModal';
import { MenuComponent } from '../../../../../_mexablock/assets/ts/components';
import { PortabilitySendModal } from '../_modals/PortabilitySendModal';
import { PortabilityDetailModal } from '../_modals/PortabilityDetailModal';
import { exportPendingExcel, exportABDTxt } from '../../../../service/operacion/Portabilidad';


const View: React.FC = () => {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { saldo } = user;
  const [loadingView, setloadingView] = useState(true);
  const [id, setId] = useState<number>(0);
  const [targetStatusName, setTargetStatusName] = useState<string>('');
  const [dataRow, setDataRow] = useState<number>(0);
  const [visivilityConfirmModal, setVisivilityConfirmModal] = useState(false);
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [visivilityTopUpModal, setVisivilityTopUpModal] = useState(false);
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');
  const [initFilterValues, setInitFilterValues] = useState({
    init_date: '',
    end_date: '',
    search: '',
  });
  const [visivilityRechargeModal, setVisivilityRechargeModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>('Todos');
  const filters = React.useMemo(() => ({
    ...initFilterValues,
    status: statusFilter !== 'Todos' ? statusFilter : ''
  }), [initFilterValues, statusFilter]);
  
  const { data, loadingRequest } = useGetAll(reloadGrid, filters);
  const [showExport, setShowExport] = useState(false);
  const [showNueva, setShowNueva] = useState(false);
  const [showChangeStatus, setShowChangeStatus] = useState(false);
  const [showEstatus, setShowEstatus] = useState(false);
  const [visivilitySendModal, setVisivilitySendModal] = useState(false);
  const [visivilityDetailModal, setVisivilityDetailModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  // Disparar recarga cuando cambien los filtros
  useEffect(() => {
    if (initFilterValues.init_date || initFilterValues.end_date || initFilterValues.search || statusFilter) {
      setReloadGrid(Math.random() * 40);
    }
  }, [initFilterValues.init_date, initFilterValues.end_date, initFilterValues.search, statusFilter]);

  // Mantener selectedRows sincronizado con la data más reciente del grid
  useEffect(() => {
    if (selectedRows.length > 0 && Array.isArray(data)) {
      setSelectedRows((prev) => {
        const mapped = prev
          .map((row) => data.find((d: any) => d.id === row.id))
          .filter(Boolean);
        return mapped;
      });
    }
  }, [data]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;
    if (regex.test(value)) {
      setInputValue(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setSearchFilter(inputValue);
      setInitFilterValues((prev) => ({ ...prev, search: inputValue }));
    }
  };

  const handleFilter = (values: any) => {
    setInitFilterValues((prev) => ({
      ...prev,
      init_date: values.init_date,
      end_date: values.end_date,
    }));
  };

  const handleRowSelected = React.useCallback((state: { selectedRows: any[] }) => {
    setSelectedRows(state.selectedRows || []);
  }, []);

  const handleClearSelection = React.useCallback(() => {
    setSelectedRows([]);
    setClearSelectedRows((prev) => !prev);
  }, []);

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: '',
      end_date: '',
      search: '',
    });
    setInputValue('');
    setSearchFilter('');
    handleClearSelection();
    setReloadGrid(Math.random() * 40);
  };

  const addRegister = () => {
    setVisivilityModal(!visivilityModal);
  };
  const topUpMultipleBalance = () => {
    setVisivilityTopUpModal(!visivilityTopUpModal);
  };


  const exportABD = async () => {
    try {
      const summary = await exportPendingExcel();
      if (summary) {
        SimpleAlert(`Archivo descargado con éxito. Registros válidos: ${summary.valid}, Descartados: ${summary.discarded}`, 5000, 'success');
      } else {
        SimpleAlert('Archivo de solicitudes para ABD descargado con éxito.', 3000, 'success');
      }
    } catch (err: any) {
      console.error('Error al exportar solicitudes para ABD:', err);
      if (err.response?.data instanceof Blob) {
        const text = await err.response.data.text();
        try {
          const json = JSON.parse(text);
          SimpleAlert(json.message || 'Error al descargar el archivo', 3000, 'error');
        } catch(e) {
          SimpleAlert('Error al descargar el archivo', 3000, 'error');
        }
      } else {
        SimpleAlert(err.response?.data?.message || 'Error al descargar el archivo de solicitudes.', 3000, 'error');
      }
    }
  };

  const exportView360 = async () => {
    try {
      const summary = await exportABDTxt();
      if (summary) {
        SimpleAlert(`Archivo descargado con éxito. Registros válidos: ${summary.valid}, Descartados: ${summary.discarded}`, 5000, 'success');
      } else {
        SimpleAlert('Archivo TXT para View360 descargado con éxito.', 3000, 'success');
      }
    } catch (err: any) {
      console.error('Error al exportar registros ABD para View360:', err);
      if (err.response?.data instanceof Blob) {
        const text = await err.response.data.text();
        try {
          const json = JSON.parse(text);
          SimpleAlert(json.message || 'Error al descargar el archivo', 3000, 'error');
        } catch(e) {
          SimpleAlert('Error al descargar el archivo', 3000, 'error');
        }
      } else {
        SimpleAlert(err.response?.data?.message || 'Error al descargar el archivo TXT.', 3000, 'error');
      }
    }
  };


  const handlerSendPortability = (id: number) => {
    setDataRow(id);
    setVisivilitySendModal(!visivilitySendModal);
  };
  const changeStatus = (id: number, statusName: string) => {
    setId(id);
    setTargetStatusName(statusName);
    setVisivilityConfirmModal(!visivilityConfirmModal);
  };
  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
      width: '110px',
    },
    {
      id: 'source',
      name: <div className="fw-bolder text-muted me-5">Canal</div>,
      selector: (row: any) => row.source,
      sortable: true,
      width: '70px',
    },
    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => (row.iccid ? row.iccid : 'Pendiente'),
      sortable: true,
      width: '180px',
    },
    {
      id: 'phone_number',
      name: <div className="fw-bolder text-muted me-5">Num.Portado</div>,
      selector: (row: any) =>
        row.phone_number ? maskPhoneNumber(row.phone_number) : 'Pendiente',
      sortable: true,
      width: '130px',
    },

    {
      id: 'customer',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) => {
        const first = row?.customer?.first_name ?? '';
        const last = row?.customer?.father_last_name ?? '';
        const fullName = `${first} ${last}`.trim();

        return fullName || 'Sin nombre';
      },
      sortable: true,
      minWidth: '150px',
    },

    {
      id: 'info_operation',
      name: <div className="fw-bolder text-muted me-5">Tipo de ejecución</div>,
      selector: (row: any) =>
        row.info_operation.is_from_activation === 1
          ? 'Desde activación'
          : 'Directa',
      sortable: true,
      width: '130px',
    },
    {
      id: 'monto',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) =>
        row.info_operation?.is_from_activation === 1
          ? '$0'
          : formatPriceMejorado(
            row.info_operation?.operation?.amount,
            'es-MX',
            'MXN'
          ),
      sortable: true,
      width: '70px',
    },
    {
      id: 'usuario',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        row.source === 'Web'
          ? `${row.user.first_name} ${row.user.father_last_name}`
          : 'Usuario App',
      sortable: true,
      minWidth: '150px',
    },
    {
      id: 'estatus',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.status.name,
      cell: (row: any) => {
        let bg = '#f4f5f8';
        let fg = '#4b5563';
        switch (row.status.name) {
          case 'No procesada': bg = '#eaf4ff'; fg = '#2f8fe0'; break;
          case 'Pendiente': bg = '#fff6e0'; fg = '#d98a10'; break;
          case 'En ABD': bg = '#f2e9fb'; fg = '#8b3fd1'; break;
          case 'Portada': bg = '#e5f7ec'; fg = '#1f9d55'; break;
          case 'Rechazada': bg = '#fdeaea'; fg = '#d64545'; break;
        }
        return (
          <span 
            className="badge py-3 px-4 fs-7"
            style={{ backgroundColor: bg, color: fg, borderRadius: '999px', fontWeight: 600 }}
          >
            {row.status.name}
          </span>
        );
      },
      sortable: true,
      width: '140px',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
      width: '60px',
    },
  ];
  const dropdownRender = (row: any) => {
    return (
      <div className="d-flex justify-content-end flex-shrink-0">
        <a
          href="#/"
          data-kt-menu="true"
          className="btn btn-light btn-active-light-primary btn-sm"
          data-kt-menu-trigger="click"
          data-kt-menu-placement="bottom-end"
        >
          Acciones
          <span className="svg-icon svg-icon-5 m-0">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
              <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="currentColor"></path>
            </svg>
          </span>
        </a>

        <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-auto py-4" data-kt-menu="true">
          <div className="menu-item px-3">
            <a className="menu-link px-3" href="#/" onClick={() => { setSelectedRow(row); setVisivilityDetailModal(true); }}>Ver detalle</a>
          </div>
          {row.status.name === 'No procesada' && (
            <div className="menu-item px-3">
              <a className="menu-link px-3" href="#/" onClick={() => handlerSendPortability(row.id)}>Enviar a portar</a>
            </div>
          )}
        </div>
      </div>
    );
  };

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              {selectedRows.length > 0 ? (
                <div className="d-flex align-items-center gap-2 bg-light-primary rounded p-3 me-4">
                  <span className="fw-bolder text-primary me-2">{selectedRows.length} seleccionado(s)</span>
                  <div style={{ position: 'relative' }}>
                  <button
                    className="btn btn-sm btn-primary"
                    onBlur={() => setTimeout(() => setShowChangeStatus(false), 150)}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowChangeStatus(!showChangeStatus);
                    }}
                  >
                    Cambiar estatus ▾
                  </button>
                  {showChangeStatus && (
                    <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4 d-block position-absolute" style={{ zIndex: 105, right: 0, top: '100%' }}>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowChangeStatus(false); changeStatus(0, 'En ABD'); }}>En ABD</a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowChangeStatus(false); changeStatus(0, 'Portada'); }}>Portada</a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3 text-danger" href="#/" onClick={(e) => { e.preventDefault(); setShowChangeStatus(false); changeStatus(0, 'No procesada'); }}>Rechazar (No procesada)</a>
                      </div>
                    </div>
                  )}
                  <button className="btn btn-sm btn-light ms-2" onClick={handleClearSelection}>Limpiar</button>
                </div>
                </div>
              ) : (
                <div className="d-flex align-items-center gap-4">
                  <Filter
                    initFilterValues={initFilterValues}
                    onCleanFilter={handleFilterClean}
                    onSearchFilter={handleFilter}
                  />
                  <div className="d-flex align-items-center position-relative me-4">
                    <span className="position-absolute ms-3" style={{ zIndex: 10 }}>
                      <i className="bi bi-search fs-4 text-muted"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-solid ps-9"
                      placeholder="ICCID"
                      maxLength={19}
                      value={inputValue}
                      onKeyDown={handleKeyDown}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              )}
              <div className="card-toolbar d-flex align-items-center gap-2">
                <div style={{ position: 'relative' }}>
                  <button
                    className="btn btn-sm btn-light"
                    onBlur={() => setTimeout(() => setShowEstatus(false), 150)}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowEstatus(!showEstatus);
                    }}
                  >
                    {statusFilter === 'Todos' ? 'Estatus' : `Estatus: ${statusFilter}`} ▾
                  </button>
                  {showEstatus && (
                    <div
                      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4 show"
                      style={{ position: 'absolute', top: '100%', right: 0, zIndex: 105, margin: 0 }}
                    >
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowEstatus(false); setStatusFilter('Todos'); }}>Todos</a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowEstatus(false); setStatusFilter('No procesada'); }}>No procesada</a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowEstatus(false); setStatusFilter('Pendiente'); }}>Pendiente</a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowEstatus(false); setStatusFilter('En ABD'); }}>En ABD</a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => { e.preventDefault(); setShowEstatus(false); setStatusFilter('Portada'); }}>Portada</a>
                      </div>
                    </div>
                  )}
                </div>

                <div style={{ position: 'relative' }}>
                  <button
                    className="btn btn-sm btn-light"
                    onBlur={() => setTimeout(() => setShowExport(false), 150)}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowExport(!showExport);
                    }}
                  >
                    Exportar ▾
                  </button>
                  {showExport && (
                    <div
                      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4 show"
                      style={{ position: 'absolute', top: '100%', right: 0, zIndex: 105, margin: 0 }}
                    >
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => {
                          e.preventDefault();
                          setShowExport(false);
                          exportABD();
                        }}>
                          Solicitudes para ABD (.xls)
                        </a>
                      </div>
                      <div className="menu-item px-3">
                        <a className="menu-link px-3" href="#/" onClick={(e) => {
                          e.preventDefault();
                          setShowExport(false);
                          exportView360();
                        }}>
                          Planchado para View360 (.txt)
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                <div style={{ position: 'relative' }}>
                  <button
                    className="btn btn-sm btn-primary"
                    onBlur={() => setTimeout(() => setShowNueva(false), 150)}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowNueva(!showNueva);
                    }}
                  >
                    + Nueva portabilidad
                  </button>
                  {showNueva && (
                    <div
                      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4 show"
                      style={{ position: 'absolute', top: '100%', right: 0, zIndex: 105, margin: 0 }}
                    >
                      <div className="menu-item px-3">
                        <a
                          className="menu-link px-3"
                          href="#/"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowNueva(false);
                            addRegister();
                          }}
                        >
                          Iniciar
                        </a>
                      </div>
                      <div className="menu-item px-3">
                        <a
                          className="menu-link px-3 text-muted"
                          href="#/"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowNueva(false);
                            setVisivilityTopUpModal(true);
                          }}
                        >
                          Desde una activación
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList 
                data={data} 
                columns={columns}
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={clearSelectedRows}
              ></TableList>
            )}
          </div>
        </div>
        <PortabilityModal
          show={visivilityModal}
          handleClose={(updateGrid: boolean) => {
            if (updateGrid) {
              // setLoadingGrid(true);
              setReloadGrid(Math.random() * 40);
            }
            // setIdRow(0);
            setVisivilityModal(!visivilityModal);
          }}
        ></PortabilityModal>
      </div>
      <PortabilitySendModal
        id={dataRow}
        show={visivilitySendModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setDataRow(0);
          setVisivilitySendModal(!visivilitySendModal);
        }}
      ></PortabilitySendModal>
      <PortabilityActivationModal
        show={visivilityTopUpModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setDataRow(0);
          setVisivilityTopUpModal(!visivilityTopUpModal);
        }}
      ></PortabilityActivationModal>

      <TopUpBalanceModal
        show={visivilityRechargeModal}
        handleClose={(updateData: boolean) => {
          setVisivilityRechargeModal(!visivilityRechargeModal);
        }}
      />
      <ConfirmModal
        show={visivilityConfirmModal}
        id={id}
        targetStatusName={targetStatusName}
        selectedRows={
          id > 0
            ? (data.find((r: any) => r.id === id) ? [data.find((r: any) => r.id === id)] : [])
            : selectedRows.map((r: any) => data.find((d: any) => d.id === r.id) || r)
        }
        handleClose={(updateData: boolean) => {
          if (updateData) {
            handleClearSelection();
            setReloadGrid(Math.random() * 40);
          }
          setId(0);
          setTargetStatusName('');
          setVisivilityConfirmModal(false);
        }}
      ></ConfirmModal>
      <PortabilityDetailModal
        show={visivilityDetailModal}
        row={selectedRow}
        handleClose={() => setVisivilityDetailModal(false)}
        openChangeStatus={changeStatus}
        openSendPortability={handlerSendPortability}
      />
    </>
  );
};

export { View };
